export function getColorsFromCssClassName(class_name) {
    switch(class_name) {
        case 'c-red':
            return '#f44336';

        case 'c-orange':
            return '#F47C00';

        case 'c-yellow':
            return '#FE9800';

        case 'c-blue':
            return '#2196f3';

        case 'c-white':
            return '#fff';

        case 'c-green':
            return '#4caf50';

        default:
            return '#000';
    }
}

export function getDeliveriesColor(parcial = {done: 0, total: 0, percent: 100}) {
    const percent = parcial.percent;

    // 0 a 24 - vermelho
    // 25 a 50 - laranja
    // 51 a 94 - amerelo
    // 95 a 100 - verde

    if(percent <= 24) {
        return 'c-red';
    } else if (percent > 24 && percent <= 50) {
        return 'c-orange';
    } else if (percent > 50 && percent < 95) {
        return 'c-orange';
    }

    return 'c-green';
}


export function getTemperatureColor(temperature) {
    // negativo - vermelho;
    // 1 e 3 - amerelo;
    // 4 e 7 - verde;
    // 7 - 10 - amarelo;
    // 10 - acima - preto;

    if(temperature < 1) {
        return 'c-red';
    } else if (temperature > 1 && temperature <= 3) {
        return 'c-orange';
    } else if (temperature > 3 && temperature <= 6) {
        return 'c-green';
    } else if (temperature > 6 && temperature <= 10) {
        return 'c-orange';
    }

    return 'c-black';
}


export function getReturnsColor(deliveries_returns = []) {
    return (deliveries_returns.length > 0) ? 'c-red' : '';
}

export function getIssuesColor(issues) {
    return (issues.length > 0) ? 'c-red' : '';
}



// WEBPACK FOOTER //
// ./src/helpers/ColorRules.js